import { render, staticRenderFns } from "./WithdrawlBalanceView.vue?vue&type=template&id=ffd25e12&scoped=true"
import script from "./WithdrawlBalanceView.vue?vue&type=script&lang=js"
export * from "./WithdrawlBalanceView.vue?vue&type=script&lang=js"
import style0 from "./WithdrawlBalanceView.vue?vue&type=style&index=0&id=ffd25e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd25e12",
  null
  
)

export default component.exports